/*
Creates a symbology collection
Renders the symbology in the collection
Provides click notification
*/
import _ = require("underscore");
import Utils = require("../utils");
import Portal = require("portal-gis");
import View = require("./view");

class Control extends View {

    static about = `
Uses _app/views/SymbologyView_ to render the symbology registered with the map.

Usage Example:

<Maplet about="Renders the symbology registered with the map" id="legend" parentId="base" text="Display Map Legend">
  <CONTROLS>
    <CONTROL about="Renders a legend of all symbologies" disabled="False" id="map-legend-controller" mid="app/controls/legend" text="Map Legend" type="startup">
      <OPTIONS>
        <Values about="Loads app/css/map-legend.css" id="css-name" value="map-legend" />
        <Values about="Render into the map-legend region (probably defined on the app-template)" id="region" value="map-legend2-region" />
        <Values id="template" value="app/templates/symbology-template" />
        <Values about="This is the full set of symbologies" id="model" value="app/data/symbology" />
      </OPTIONS>
    </CONTROL>
    <CONTROL about="Renders a legend of features actually on the map" disabled="False" id="map-feature-legend-controller" mid="app/controls/legend" text="Map Features" type="startup">
      <OPTIONS>
        <Values about="Loads app/css/map-legend.css" id="css-name" value="map-legend" />
        <Values about="Render into the map-legend region (probably defined on the app-template)" id="region" value="map-legend-region" />
        <Values id="template" value="app/templates/symbology-feature-template" />
        <Values about="This is the full set of symbologies" id="model" value="app/data/features" />
      </OPTIONS>
    </CONTROL>
  </CONTROLS>
  <EVENTS>
    <EVENT event="symbology-selected" id="symbology-selected" mid="app/commands/alert">
      <OPTIONS>
        <Values id="message" value="Legend Item Clicked" />
      </OPTIONS>
    </EVENT>
  </EVENTS>
</Maplet>

    `;

    static options = {
        "region": {
            "default": "legend-region",
        },
        "view": {
            "default": "app/views/SymbologyView",
        },
    }

    execute(args = this.args) {
        // do anything that needs to be done before the view gets created here
        let options = _.defaults(this.options, {
            model: this.mediator.api.symbology,
            view: Control.options.view.default,
            region: Control.options.region.default,
        });
    }

    broadcast() {
        // do anything that needs to be done after the view is created here
        this.view.on("symbology-selected", args => {
            this.trigger("symbology-selected", args);
        });

        super.broadcast();
    }

}

export = Control;